import { NavLink, Link } from 'react-router-dom'
import { FaShare } from 'react-icons/fa'
import { AiOutlineLink } from 'react-icons/ai';
import { alert_error, alert_success } from "../../AppContext.js";
function ProfileNav({ username }) {
  const handleShareClick = () => {
    // Gọi API để mở phương thức chia sẻ mặc định
    navigator.share({
      title: 'Chia sẻ từ trang của tôi',
      url: 'http://hust.media/shop/profile/' + username,
    })
      .then(() => {
        console.log('Chia sẻ thành công!');
      })
      .catch(error => {
        console.error('Lỗi khi chia sẻ: ', error);
      });
  }
  function saochep(value) {
    alert_success('Đã sao chép');
    window.saochepnative(value);

  };
  return (
    <ul className='-mb-px flex flex-wrap p-0 gap-2'>



      {window.location.pathname.startsWith("/shop/editprofile")
        || window.location.pathname.startsWith("/shop/ads") || window.location.pathname.startsWith("/shop/editcategory") ? (
        <>
          <li className='mr-1 '>
            <NavLink
              end
              to={`/shop/editprofile`}
              className={({ isActive }) => {
                return `inline-block rounded-t-lg border-b-2 text-black no-underline ${isActive
                  ? 'border-blue-600  text-blue-600'
                  : 'border-transparent  hover:border-gray-300 hover:text-gray-600'
                  }`
              }}
            >
              Mô tả
            </NavLink>
          </li>
          {/* <li className='mr-1'>
            <Link to="/shop/editcategory/post">

              <div className=
                "inline-block rounded-t-lg border-b-2 text-black no-underline"  >
                Gian hàng  </div>
            </Link>
          </li>   */}
          <li className='mr-1'>
            <NavLink
              to={`../editcategory`}
              className={({ isActive }) =>
                `inline-block rounded-t-lg border-b-2 text-black no-underline ${isActive
                  ? 'border-blue-600  text-blue-600'
                  : 'border-transparent  hover:border-gray-300 hover:text-gray-600'
                } `
              }
              aria-current='page'
            >
              Gian hàng
            </NavLink>

          </li>
          <li className='mr-1'>
            <NavLink
              to={`../ads/adsprofiles`}
              className={({ isActive }) =>
                `inline-block rounded-t-lg border-b-2 text-black no-underline ${isActive
                  ? 'border-blue-600  text-blue-600'
                  : 'border-transparent  hover:border-gray-300 hover:text-gray-600'
                } `
              }
              aria-current='page'
            >
              Quảng cáo
            </NavLink>

          </li>
          <li className='mr-1'>
            <Link  to={`/shop/profile/${username}`}>

              <div className=
                "inline-block rounded-t-lg  text-black no-underline"  >
                Preview </div>
            </Link>
          </li>
        </>

      )
        :
        (
          <>
            <li className='mr-1 '>
              <NavLink
                end
                to={`/shop/profile/${username}`}
                className={({ isActive }) => {
                  return `inline-block rounded-t-lg border-b-2 text-black no-underline ${isActive
                    ? 'border-blue-600  text-blue-600'
                    : 'border-transparent  hover:border-gray-300 hover:text-gray-600'
                    }`
                }}
              >
                Mô tả
              </NavLink>
            </li>    <li className='mr-1'>
              <NavLink
                to={`./products`}
                className={({ isActive }) =>
                  `inline-block rounded-t-lg border-b-2 text-black no-underline ${isActive
                    ? 'border-blue-600  text-blue-600'
                    : 'border-transparent  hover:border-gray-300 hover:text-gray-600'
                  } `
                }
                aria-current='page'
              >
                Gian hàng
              </NavLink>
            </li>

          </>

        )}


      <li className='mr-0'>
        <button onClick={handleShareClick}>
          <FaShare />
        </button>
      </li>
      <li className='mr-0'>
        <button onClick={() => saochep(window.location.href)}  >
          <AiOutlineLink />
        </button>
      </li>
    </ul>
  )
}
export default ProfileNav
